import { SkinnedMeshRenderer } from "../../../d3/core/SkinnedMeshRenderer";
import { WebGLEngine } from "../RenderDevice/WebGLEngine";
import { WebGLRenderElement3D } from "./WebGLRenderElement3D";
export class WebGLSkinRenderElement3D extends WebGLRenderElement3D {
    constructor() {
        super();
    }
    drawGeometry(shaderIns) {
        let element = this.geometry.drawParams.elements;
        if (!this.skinnedData)
            return;
        this.geometry.bufferState.bind();
        let shaderVariable = shaderIns._cacheShaerVariable[SkinnedMeshRenderer.BONES];
        if (!shaderVariable) {
            for (var i = 0, n = shaderIns._spriteUniformParamsMap._idata.length; i < n; i++) {
                if (shaderIns._spriteUniformParamsMap._idata[i].dataOffset == SkinnedMeshRenderer.BONES) {
                    shaderVariable = shaderIns._spriteUniformParamsMap._idata[i];
                    shaderIns._cacheShaerVariable[SkinnedMeshRenderer.BONES] = shaderVariable;
                    break;
                }
            }
        }
        for (var j = 0, m = this.geometry.drawParams.length / 2; j < m; j++) {
            var subSkinnedDatas = this.skinnedData[j];
            WebGLEngine.instance.uploadOneUniforms(shaderIns._renderShaderInstance, shaderVariable, subSkinnedDatas);
            var offset = j * 2;
            WebGLEngine.instance.getDrawContext().drawElements(this.geometry._glmode, element[offset + 1], this.geometry._glindexFormat, element[offset]);
        }
    }
}
